/**
 * Champ d'étoiles déterministe (graine fixe → SSR-safe, aucun mismatch
 * d'hydratation). Rend une liste de box-shadows à poser sur un div 1×1px.
 * Extrait du hero « Aube logistique » pour être partagé avec les autres
 * scènes nuit (ex. hero /tarifs).
 */
function mulberry32(seed: number) {
  return () => {
    seed |= 0
    seed = (seed + 0x6d2b79f5) | 0
    let t = Math.imul(seed ^ (seed >>> 15), 1 | seed)
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}

export function buildStars(
  count: number,
  seed: number,
  sizes: number[],
  accentEvery: number,
  maxYvh = 68,
) {
  const rnd = mulberry32(seed)
  const shadows: string[] = []
  for (let i = 0; i < count; i++) {
    const x = Math.round(rnd() * 100 * 100) / 100
    const y = Math.round(rnd() * maxYvh * 100) / 100
    const s = sizes[i % sizes.length]
    const accent = accentEvery > 0 && i % accentEvery === 0
    const a = 0.25 + rnd() * 0.35
    const color = accent ? `rgba(188,208,255,${a + 0.15})` : `rgba(255,255,255,${a})`
    shadows.push(`${x}vw ${y}vh 0 ${s > 1 ? `${(s - 1) / 2}px` : '0'} ${color}`)
  }
  return shadows.join(',')
}
